import {forgotPassword} from '../.././../libs/api/api'
import constants from '../../../libs/constant/constants'
import {message, errorHandler, loader} from '../../../libs/helper'


export default {
    name:'ForgotPasswordForm',
    data () {
        return {
            successMessage: false,
            dynamicValidateForm: {
                email: ''
            }
        }
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    loader(this, true);
                    forgotPassword(this.dynamicValidateForm)
                        .then((response) => {
                            if(response.success){
                                this.successMessage = true
                                message(this, constants.messageType.SUCCESS, ('An email has been sent to your email address'))
                                loader(this, false);
                            }
                        })
                        .catch((error) => {
                            loader(this, false);
                            message(this, constants.messageType.ERROR, errorHandler(error))
                        })
                }
            })
        },
        onEnter (e) {
            if (e.key === "Enter") {
                e.preventDefault()
                this.submitForm('dynamicValidateForm')
            }
        }
    }
}